import { render, staticRenderFns } from "./vistaCompromisosDeudor.vue?vue&type=template&id=2f517497&scoped=true"
import script from "./vistaCompromisosDeudor.vue?vue&type=script&lang=js"
export * from "./vistaCompromisosDeudor.vue?vue&type=script&lang=js"
import style0 from "./vistaCompromisosDeudor.vue?vue&type=style&index=0&id=2f517497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f517497",
  null
  
)

export default component.exports